import { Component } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-claim-history-page',
    template: `
    <app-section>
      <app-claim-breadcrumb></app-claim-breadcrumb>
      <app-claim-history [translationRequest]="translationRequest" class="tw-w-full"></app-claim-history>
    </app-section>
  `,
    styles: [],
    standalone: false
})
export class ClaimHistoryPageComponent {
  translationRequest = new TranslationRequest({
        language: sessionStorage.getItem('languagepreference'),
        key: null,
        contNum: 0,
        tableName: null,
        primaryKey: null,
        primaryValue: null,
        lob: null,
        group: 'History',
        subGroup: 'History',
      });
}
